/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "flight_deck";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface RgbLedMode {
}

export enum RgbLedMode_Enum {
  DEFAULT_RGB_LED = 0,
  AVIATION_RGB_LED = 1,
  UNRECOGNIZED = -1,
}

export function rgbLedMode_EnumFromJSON(object: any): RgbLedMode_Enum {
  switch (object) {
    case 0:
    case "DEFAULT_RGB_LED":
      return RgbLedMode_Enum.DEFAULT_RGB_LED;
    case 1:
    case "AVIATION_RGB_LED":
      return RgbLedMode_Enum.AVIATION_RGB_LED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return RgbLedMode_Enum.UNRECOGNIZED;
  }
}

export function rgbLedMode_EnumToJSON(object: RgbLedMode_Enum): string {
  switch (object) {
    case RgbLedMode_Enum.DEFAULT_RGB_LED:
      return "DEFAULT_RGB_LED";
    case RgbLedMode_Enum.AVIATION_RGB_LED:
      return "AVIATION_RGB_LED";
    case RgbLedMode_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseRgbLedMode(): RgbLedMode {
  return {};
}

export const RgbLedMode = {
  encode(_: RgbLedMode, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RgbLedMode {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRgbLedMode();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): RgbLedMode {
    return {};
  },

  toJSON(_: RgbLedMode): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<RgbLedMode>, I>>(base?: I): RgbLedMode {
    return RgbLedMode.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RgbLedMode>, I>>(_: I): RgbLedMode {
    const message = createBaseRgbLedMode();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
